// ─── Workflow Kanban seed data, columns, tags ─────────────────────────────────

export const DEFAULT_COLUMNS = [
  { id: 'active',    label: 'Active Estimates',     color: '#2E8BF0', canDelete: false },
  { id: 'deposit',   label: 'Waiting for Deposit',  color: '#F59E0B', canDelete: true  },
  { id: 'followup',  label: 'Follow Ups',           color: '#8B5CF6', canDelete: true  },
  { id: 'scheduled', label: 'Scheduled',            color: '#22C55E', canDelete: true  },
  { id: 'inprog',    label: 'In Progress',          color: '#06B6D4', canDelete: true  },
  { id: 'invoice',   label: 'Final Invoice',        color: '#F97316', canDelete: true  },
  { id: 'dead',      label: 'Work Done – Not Paid', color: '#EF4444', canDelete: true  },
  { id: 'complete',  label: 'Complete',             color: '#10B981', canDelete: false },
];

// Preset column colors for new columns
export const COLUMN_COLOR_PRESETS = [
  '#2E8BF0', '#F59E0B', '#8B5CF6', '#22C55E',
  '#06B6D4', '#F97316', '#EF4444', '#10B981',
];

// Tag color themes
export const TAG_COLORS = {
  VIP:              { bg: 'rgba(245,158,11,0.15)', text: '#D97706', border: 'rgba(245,158,11,0.3)'  },
  Rush:             { bg: 'rgba(239,68,68,0.12)',  text: '#DC2626', border: 'rgba(239,68,68,0.3)'   },
  Fleet:            { bg: 'rgba(99,102,241,0.12)', text: '#6366F1', border: 'rgba(99,102,241,0.3)'  },
  PPF:              { bg: 'rgba(6,182,212,0.12)',  text: '#0891B2', border: 'rgba(6,182,212,0.3)'   },
  Blackout:         { bg: 'rgba(15,23,42,0.15)',   text: '#94A3B8', border: 'rgba(100,116,139,0.4)' },
  Cold:             { bg: 'rgba(14,165,233,0.1)',  text: '#0284C7', border: 'rgba(14,165,233,0.3)'  },
  Referral:         { bg: 'rgba(34,197,94,0.1)',   text: '#16A34A', border: 'rgba(34,197,94,0.3)'   },
  'Repeat Client':  { bg: 'rgba(139,92,246,0.1)',  text: '#7C3AED', border: 'rgba(139,92,246,0.3)'  },
  Warranty:         { bg: 'rgba(249,115,22,0.1)',  text: '#EA580C', border: 'rgba(249,115,22,0.3)'  },
};

export const ASSIGNEES = ['Tavo R.', 'Maria L.', 'Daniel V.', 'Chris M.'];

export const PRIORITY_META = {
  normal: { label: 'Normal', color: '#94A3B8' },
  high:   { label: 'High',   color: '#F59E0B' },
  urgent: { label: 'Urgent', color: '#EF4444' },
};

const now = Date.now();
const dayMs = 86400000;
const iso = (offsetDays = 0) => new Date(now + offsetDays * dayMs).toISOString();

// ─── 22 seed estimates spread across all columns ─────────────────────────────
export const SEED_ESTIMATES = [
  // active
  {
    id: 'EST-3799',
    type: 'estimate',
    title: 'Window Tint - Two (2) Doors and 1 more',
    services: ['Window Tint', 'Door Tint'],
    columnId: 'active',
    vehicle: { year: 2026, make: 'Land Rover', model: 'Range Rover Sport', vin: 'SAL1L9E90TA634357', type: 'SUV' },
    customer: { name: 'Eric Brooks', phone: '(818) 970-6116', email: 'eric.brooks@example.com' },
    tags: ['VIP'],
    total: 7156.01,
    paid: 207.00,
    paymentStatus: 'partial',
    daysInColumn: 1,
    scheduledDate: null,
    assignee: 'Tavo R.',
    priority: 'high',
    note: 'Customer wants matte ceramic finish',
    createdAt: iso(-1),
  },
  {
    id: 'EST-3801',
    type: 'estimate',
    title: 'Chrome Delete - Trim and Badges',
    services: ['Chrome Delete'],
    columnId: 'active',
    vehicle: { year: 2024, make: 'BMW', model: 'M4 Competition', vin: 'WBS83AC03RFR12398', type: 'Coupe' },
    customer: { name: 'Priya Nair', phone: '(310) 555-2088', email: 'priya@example.com' },
    tags: ['PPF', 'Repeat Client'],
    total: 2850.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 0,
    scheduledDate: null,
    assignee: null,
    priority: 'normal',
    note: '',
    createdAt: iso(0),
  },
  {
    id: 'EST-3812',
    type: 'estimate',
    title: 'Full Vehicle PPF - XPEL Stealth',
    services: ['Full Vehicle PPF', 'XPEL Stealth'],
    columnId: 'active',
    vehicle: { year: 2023, make: 'Porsche', model: '911 Turbo S', vin: 'WP0AD2A99PS267801', type: 'Coupe' },
    customer: { name: 'Marcus Bell', phone: '(424) 555-0143', email: 'm.bell@example.com' },
    tags: ['VIP', 'PPF', 'Rush'],
    total: 17850.00,
    paid: 5000.00,
    paymentStatus: 'partial',
    daysInColumn: 2,
    scheduledDate: null,
    assignee: 'Chris M.',
    priority: 'urgent',
    note: 'Rush for Pebble Beach show',
    createdAt: iso(-2),
  },

  // deposit
  {
    id: 'EST-3755',
    type: 'estimate',
    title: 'Color Change - Gloss Black Full Wrap',
    services: ['Full Wrap', 'Color Change – Gloss Black'],
    columnId: 'deposit',
    vehicle: { year: 2023, make: 'Tesla', model: 'Model S Plaid', vin: '5YJSA1E68PF123456', type: 'Sedan' },
    customer: { name: 'Jordan Cole', phone: '(213) 555-9812', email: 'jordan.cole@example.com' },
    tags: ['Rush'],
    total: 6200.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 4,
    scheduledDate: null,
    assignee: 'Maria L.',
    priority: 'high',
    note: 'Awaiting 50% deposit',
    createdAt: iso(-4),
  },
  {
    id: 'EST-3760',
    type: 'estimate',
    title: 'Hood PPF + Ceramic Coating',
    services: ['Hood PPF', 'Ceramic Coating'],
    columnId: 'deposit',
    vehicle: { year: 2025, make: 'Audi', model: 'RS6 Avant', vin: 'WUAWFAFX0P0900123', type: 'Wagon' },
    customer: { name: 'Remi Santos', phone: '(714) 555-4422', email: 'remi@example.com' },
    tags: ['PPF'],
    total: 3400.00,
    paid: 500.00,
    paymentStatus: 'partial',
    daysInColumn: 3,
    scheduledDate: null,
    assignee: 'Daniel V.',
    priority: 'normal',
    note: '',
    createdAt: iso(-3),
  },
  {
    id: 'EST-3768',
    type: 'estimate',
    title: 'Partial Wrap - Roof and Mirrors',
    services: ['Partial Wrap', 'Roof Wrap'],
    columnId: 'deposit',
    vehicle: { year: 2022, make: 'Mercedes', model: 'G-Wagon 63', vin: 'W1NWF8HBXNX789456', type: 'SUV' },
    customer: { name: 'Carla Reyes', phone: '(818) 555-3399', email: 'carla.reyes@example.com' },
    tags: ['VIP', 'Repeat Client'],
    total: 4450.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 9,
    scheduledDate: null,
    assignee: null,
    priority: 'normal',
    note: 'Following up Wednesday',
    createdAt: iso(-9),
  },

  // followup
  {
    id: 'EST-3702',
    type: 'estimate',
    title: 'Full Wrap - Satin White',
    services: ['Full Wrap – Satin White'],
    columnId: 'followup',
    vehicle: { year: 2021, make: 'Ford', model: 'F-150 Raptor', vin: '1FTFW1RG2MFA12345', type: 'Truck' },
    customer: { name: 'Devon Walsh', phone: '(562) 555-7712', email: 'devon@example.com' },
    tags: ['Cold'],
    total: 8900.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 14,
    scheduledDate: null,
    assignee: 'Tavo R.',
    priority: 'normal',
    note: 'Customer went quiet – try again Friday',
    createdAt: iso(-14),
  },
  {
    id: 'EST-3689',
    type: 'estimate',
    title: 'Window Tint - Full Vehicle Ceramic',
    services: ['Window Tint', 'Ceramic Tint'],
    columnId: 'followup',
    vehicle: { year: 2020, make: 'Jeep', model: 'Wrangler Rubicon', vin: '1C4HJXFN5LW123789', type: 'SUV' },
    customer: { name: 'Aisha Owens', phone: '(949) 555-2211', email: 'aisha@example.com' },
    tags: ['Referral'],
    total: 1250.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 7,
    scheduledDate: null,
    assignee: null,
    priority: 'normal',
    note: '',
    createdAt: iso(-7),
  },
  {
    id: 'EST-3717',
    type: 'estimate',
    title: 'Fleet Wrap - 3 Ford Transits',
    services: ['Fleet Wrap', 'Branding'],
    columnId: 'followup',
    vehicle: { year: 2024, make: 'Ford', model: 'Transit 350', vin: '1FTBR1Y88PKA34567', type: 'Van' },
    customer: { name: 'Finn O\'Brien', phone: '(323) 555-6611', email: 'finn.obrien@example.com' },
    tags: ['Fleet', 'Cold'],
    total: 13400.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 21,
    scheduledDate: null,
    assignee: 'Maria L.',
    priority: 'high',
    note: 'Pending approval from accounting',
    createdAt: iso(-21),
  },

  // scheduled
  {
    id: 'EST-3820',
    type: 'estimate',
    title: 'Roof Wrap - Gloss Black',
    services: ['Roof Wrap'],
    columnId: 'scheduled',
    vehicle: { year: 2023, make: 'Chevy', model: 'Silverado 1500', vin: '1GCUYGED5PZ123456', type: 'Truck' },
    customer: { name: 'Kyle Huang', phone: '(626) 555-8822', email: 'kyle@example.com' },
    tags: ['Blackout'],
    total: 1850.00,
    paid: 925.00,
    paymentStatus: 'partial',
    daysInColumn: 2,
    scheduledDate: iso(3),
    assignee: 'Tavo R.',
    priority: 'normal',
    note: 'Scheduled for Thursday AM',
    createdAt: iso(-2),
  },
  {
    id: 'EST-3822',
    type: 'estimate',
    title: 'Full Vehicle PPF + Window Tint',
    services: ['Full Vehicle PPF', 'Window Tint'],
    columnId: 'scheduled',
    vehicle: { year: 2025, make: 'Rivian', model: 'R1T', vin: '7FCTGAAL2PN012345', type: 'Truck' },
    customer: { name: 'Layla Dixon', phone: '(805) 555-1144', email: 'layla.dixon@example.com' },
    tags: ['PPF', 'VIP'],
    total: 12800.00,
    paid: 6400.00,
    paymentStatus: 'partial',
    daysInColumn: 1,
    scheduledDate: iso(5),
    assignee: 'Chris M.',
    priority: 'high',
    note: '',
    createdAt: iso(-1),
  },
  {
    id: 'EST-3825',
    type: 'estimate',
    title: 'Chrome Delete + Badge Blackout',
    services: ['Chrome Delete', 'Badge Blackout'],
    columnId: 'scheduled',
    vehicle: { year: 2024, make: 'Dodge', model: 'Challenger Hellcat', vin: '2C3CDZFJ8RH123456', type: 'Coupe' },
    customer: { name: 'Marco Lima', phone: '(951) 555-6633', email: 'marco@example.com' },
    tags: ['Blackout', 'Repeat Client'],
    total: 1650.00,
    paid: 825.00,
    paymentStatus: 'partial',
    daysInColumn: 0,
    scheduledDate: iso(2),
    assignee: 'Daniel V.',
    priority: 'normal',
    note: '',
    createdAt: iso(0),
  },

  // inprog
  {
    id: 'EST-3700',
    type: 'estimate',
    title: 'Full Vehicle PPF - XPEL Stealth',
    services: ['Full Vehicle PPF', 'XPEL Stealth'],
    columnId: 'inprog',
    vehicle: { year: 2024, make: 'Lamborghini', model: 'Urus Performante', vin: 'ZPBUA1ZL6RLA12345', type: 'SUV' },
    customer: { name: 'Tina Marsh', phone: '(310) 555-9090', email: 'tina@example.com' },
    tags: ['VIP', 'PPF', 'Rush'],
    total: 18400.00,
    paid: 9200.00,
    paymentStatus: 'partial',
    daysInColumn: 3,
    scheduledDate: null,
    assignee: 'Chris M.',
    priority: 'urgent',
    note: 'Day 3 of 5 – on track',
    createdAt: iso(-3),
  },
  {
    id: 'EST-3695',
    type: 'estimate',
    title: 'Partial Wrap - Hood and Roof',
    services: ['Partial Wrap', 'Hood PPF'],
    columnId: 'inprog',
    vehicle: { year: 2024, make: 'Toyota', model: 'Tundra TRD Pro', vin: '5TFWC5DB9RX123456', type: 'Truck' },
    customer: { name: 'Chris Benitez', phone: '(760) 555-3311', email: 'chris.b@example.com' },
    tags: [],
    total: 3950.00,
    paid: 1975.00,
    paymentStatus: 'partial',
    daysInColumn: 1,
    scheduledDate: null,
    assignee: 'Tavo R.',
    priority: 'normal',
    note: '',
    createdAt: iso(-1),
  },

  // invoice
  {
    id: 'INV-2204',
    type: 'invoice',
    title: 'Full Wrap - Satin Metallic Blue',
    services: ['Full Wrap', 'Color Change'],
    columnId: 'invoice',
    vehicle: { year: 2023, make: 'Cadillac', model: 'Escalade Sport', vin: '1GYS4NKL8PR123456', type: 'SUV' },
    customer: { name: 'Alicia Green', phone: '(818) 555-7744', email: 'alicia.green@example.com' },
    tags: ['VIP'],
    total: 9850.00,
    paid: 5000.00,
    paymentStatus: 'partial',
    daysInColumn: 2,
    scheduledDate: null,
    assignee: 'Maria L.',
    priority: 'high',
    note: 'Invoice sent – awaiting final payment',
    createdAt: iso(-2),
  },
  {
    id: 'INV-2198',
    type: 'invoice',
    title: 'Window Tint - Full Vehicle',
    services: ['Window Tint'],
    columnId: 'invoice',
    vehicle: { year: 2024, make: 'Honda', model: 'Ridgeline Black Ed.', vin: '5FPYK3F85RB012345', type: 'Truck' },
    customer: { name: 'Hiro Tanaka', phone: '(714) 555-4477', email: 'hiro@example.com' },
    tags: ['Referral'],
    total: 1320.00,
    paid: 1320.00,
    paymentStatus: 'paid',
    daysInColumn: 1,
    scheduledDate: null,
    assignee: 'Daniel V.',
    priority: 'normal',
    note: '',
    createdAt: iso(-1),
  },

  // dead (work done, not paid)
  {
    id: 'INV-2176',
    type: 'invoice',
    title: 'Partial Wrap + Chrome Delete',
    services: ['Partial Wrap', 'Chrome Delete'],
    columnId: 'dead',
    vehicle: { year: 2022, make: 'Kia', model: 'Telluride SX', vin: '5XYP5DHC5NG123456', type: 'SUV' },
    customer: { name: 'Reina Alvarez', phone: '(562) 555-9988', email: 'reina@example.com' },
    tags: ['Warranty'],
    total: 2450.00,
    paid: 1000.00,
    paymentStatus: 'partial',
    daysInColumn: 12,
    scheduledDate: null,
    assignee: 'Maria L.',
    priority: 'high',
    note: 'Customer unresponsive to final invoice',
    createdAt: iso(-12),
  },
  {
    id: 'INV-2163',
    type: 'invoice',
    title: 'Ceramic Coating - Full Exterior',
    services: ['Ceramic Coating'],
    columnId: 'dead',
    vehicle: { year: 2021, make: 'BMW', model: 'X5 M50i', vin: '5UXJU2C00M9A12345', type: 'SUV' },
    customer: { name: 'Nathan Price', phone: '(213) 555-2266', email: 'n.price@example.com' },
    tags: ['Cold'],
    total: 1900.00,
    paid: 0,
    paymentStatus: 'unpaid',
    daysInColumn: 18,
    scheduledDate: null,
    assignee: 'Chris M.',
    priority: 'urgent',
    note: 'Second invoice sent',
    createdAt: iso(-18),
  },

  // complete
  {
    id: 'INV-2150',
    type: 'invoice',
    title: 'Full Vehicle PPF - XPEL Ultimate',
    services: ['Full Vehicle PPF'],
    columnId: 'complete',
    vehicle: { year: 2024, make: 'Tesla', model: 'Model X Plaid', vin: '7SAXCBE60RF123456', type: 'SUV' },
    customer: { name: 'Sienna Park', phone: '(310) 555-4411', email: 'sienna@example.com' },
    tags: ['PPF', 'Repeat Client'],
    total: 15200.00,
    paid: 15200.00,
    paymentStatus: 'paid',
    daysInColumn: 3,
    scheduledDate: null,
    assignee: 'Chris M.',
    priority: 'normal',
    note: '',
    createdAt: iso(-3),
  },
  {
    id: 'INV-2145',
    type: 'invoice',
    title: 'Full Wrap - Satin White',
    services: ['Full Wrap – Satin White'],
    columnId: 'complete',
    vehicle: { year: 2023, make: 'Ford', model: 'F-150 Raptor R', vin: '1FTFW1RJ0PFA67890', type: 'Truck' },
    customer: { name: 'Trevor Klein', phone: '(818) 555-5533', email: 'trevor@example.com' },
    tags: ['VIP'],
    total: 8650.00,
    paid: 8650.00,
    paymentStatus: 'paid',
    daysInColumn: 5,
    scheduledDate: null,
    assignee: 'Tavo R.',
    priority: 'normal',
    note: '',
    createdAt: iso(-5),
  },
  {
    id: 'INV-2142',
    type: 'invoice',
    title: 'Window Tint + Chrome Delete',
    services: ['Window Tint', 'Chrome Delete'],
    columnId: 'complete',
    vehicle: { year: 2024, make: 'Audi', model: 'RS6 Performance', vin: 'WUAPCBFX7R0001234', type: 'Wagon' },
    customer: { name: 'Jasmine Wu', phone: '(949) 555-1199', email: 'jasmine@example.com' },
    tags: ['Blackout'],
    total: 2150.00,
    paid: 2150.00,
    paymentStatus: 'paid',
    daysInColumn: 8,
    scheduledDate: null,
    assignee: 'Daniel V.',
    priority: 'normal',
    note: '',
    createdAt: iso(-8),
  },
];

// ─── helpers ──────────────────────────────────────────────────────────────────

export function formatCurrency(n) {
  return `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDaysInColumn(days) {
  if (days === 0) return { label: 'Today', tone: 'normal' };
  if (days === 1) return { label: '1d',    tone: 'normal' };
  if (days < 7)   return { label: `${days}d`, tone: 'normal' };
  if (days < 14)  return { label: `${days}d`, tone: 'warn'   };
  return { label: `${days}d`, tone: 'danger' };
}
